(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackStateOffersController', WinbackStateOffersController);

    WinbackStateOffersController.$inject = ['$state',];

    function WinbackStateOffersController($state) {
        // var vm = this;

        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'winbackStateOffers') {
                $state.go('winbackStateOffers.list');
            }
        }
    }
})();